import { render, staticRenderFns } from "./result_make.vue?vue&type=template&id=3fc106f0&scoped=true&"
import script from "./result_make.vue?vue&type=script&lang=js&"
export * from "./result_make.vue?vue&type=script&lang=js&"
import style0 from "./result_make.vue?vue&type=style&index=0&id=3fc106f0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc106f0",
  null
  
)

export default component.exports